import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { swSettings } from "app/common/services/swSettings";

import {
    ONBOARDING_AGENT_GREETING_BODY,
    ONBOARDING_AGENT_GREETING_FIRST_BODY,
    ONBOARDING_AGENT_GREETING_FIRST_HEADLINE_AFTER,
    ONBOARDING_AGENT_GREETING_FIRST_HEADLINE_FALLBACK,
    ONBOARDING_AGENT_GREETING_HEADLINE_AFTER,
    ONBOARDING_AGENT_GREETING_HEADLINE_BEFORE,
    ONBOARDING_AGENT_GREETING_HEADLINE_FALLBACK,
} from "../texts";

import { normalizeTranslationNewlines } from "./helpers/greetingUtils";
import { BodyText, FirstNameAccent, GreetingRoot, HeadlineParagraph } from "./styles";

type OnboardingAgentGreetingProps = {
    isFirstOpen: boolean;
};

export const OnboardingAgentGreeting = ({ isFirstOpen }: OnboardingAgentGreetingProps) => {
    const { translate } = useTranslate();
    const firstName = String(swSettings?.user?.firstname ?? "").trim();

    const headlineAfterKey = isFirstOpen
        ? ONBOARDING_AGENT_GREETING_FIRST_HEADLINE_AFTER
        : ONBOARDING_AGENT_GREETING_HEADLINE_AFTER;
    const headlineFallbackKey = isFirstOpen
        ? ONBOARDING_AGENT_GREETING_FIRST_HEADLINE_FALLBACK
        : ONBOARDING_AGENT_GREETING_HEADLINE_FALLBACK;
    const bodyKey = isFirstOpen ? ONBOARDING_AGENT_GREETING_FIRST_BODY : ONBOARDING_AGENT_GREETING_BODY;

    return (
        <GreetingRoot data-automation="onboarding-agent-greeting">
            <HeadlineParagraph>
                {firstName ? (
                    <>
                        {!isFirstOpen ? (
                            <Text
                                as="span"
                                fontVariant="subtitle1"
                                color={colorsPalettes.carbon[500]}
                            >
                                {`${translate(ONBOARDING_AGENT_GREETING_HEADLINE_BEFORE)} `}
                            </Text>
                        ) : null}
                        <FirstNameAccent>{firstName}</FirstNameAccent>
                        <Text
                            as="span"
                            fontVariant="subtitle1"
                            color={colorsPalettes.carbon[500]}
                        >
                            {translate(headlineAfterKey)}
                        </Text>
                    </>
                ) : (
                    <Text
                        as="span"
                        fontVariant="subtitle1"
                        color={colorsPalettes.carbon[500]}
                    >
                        {translate(headlineFallbackKey)}
                    </Text>
                )}
            </HeadlineParagraph>
            <BodyText
                fontVariant="body1"
                color={colorsPalettes.carbon[500]}
            >
                {normalizeTranslationNewlines(translate(bodyKey))}
            </BodyText>
        </GreetingRoot>
    );
};
